import { render, staticRenderFns } from "./ImgProductVertical.vue?vue&type=template&id=4f098989&"
import script from "./ImgProductVertical.vue?vue&type=script&lang=js&"
export * from "./ImgProductVertical.vue?vue&type=script&lang=js&"
import style0 from "./ImgProductVertical.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports